import { OrderedMap } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';

export const globalSearchReducer = (state = new OrderedMap(), action) => {
  switch (action.type) {
    case 'STARTING_GLOBAL_SEARCH':
    case 'GLOBAL_SEARCH_CLEARED':
      return new OrderedMap();
    case 'GLOBAL_SEARCH_DATA_LOADED':
      // eslint-disable-next-line
      return OrderedMap(action.data);
    default:
      return state;
  }
};
export const clearSearch = (dispatch) => dispatch({ type: 'GLOBAL_SEARCH_CLEARED' });
export const search = (dispatch, text) => {
  dispatch({ type: 'STARTING_GLOBAL_SEARCH', text });
  return RestAPI.get(`/search/api/global?value=${text}`)
    .then(
      (data) => {
        dispatch({ type: 'GLOBAL_SEARCH_DATA_LOADED', data });
        dispatch({ type: 'SEARCH_FINISHED' });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'GLOBAL_SEARCH_LOADING_FAILED' });
        dispatch({ type: 'SEARCH_FINISHED' });
        return true;
      },
    );
};
